const logoutUser = (navigate, message = "Session expired. Please login again ❗") => {

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("student");

    navigate("/Login", {
        replace: true,
        state: { message }
    });
};

export default logoutUser;